import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledPlaceholder = styled(Box)`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.38);
`;
